/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEnrollEmailResponse
 */
export interface ControlEnrollEmailResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlEnrollEmailResponse
     */
    oob_code: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEnrollEmailResponse
     */
    recovery_code: string;
    /**
     * 
     * @type {string}
     * @memberof ControlEnrollEmailResponse
     */
    emailed_to: string;
}

/**
 * Check if a given object implements the ControlEnrollEmailResponse interface.
 */
export function instanceOfControlEnrollEmailResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "oob_code" in value;
    isInstance = isInstance && "recovery_code" in value;
    isInstance = isInstance && "emailed_to" in value;

    return isInstance;
}

export function ControlEnrollEmailResponseFromJSON(json: any): ControlEnrollEmailResponse {
    return ControlEnrollEmailResponseFromJSONTyped(json, false);
}

export function ControlEnrollEmailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEnrollEmailResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oob_code': json['oob_code'],
        'recovery_code': json['recovery_code'],
        'emailed_to': json['emailed_to'],
    };
}

export function ControlEnrollEmailResponseToJSON(value?: ControlEnrollEmailResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oob_code': value.oob_code,
        'recovery_code': value.recovery_code,
        'emailed_to': value.emailed_to,
    };
}

